module.exports = __webpack_public_path__ + "static/yonas-fshot-kesto-ecd46b1417c0e87e07fa3f85a4a322a8.jpeg";